/**
 * Bundled withdraw coin/network rows for local UI when `GET /api/v1/wallet/withdrawal-coins`
 * is empty or unreachable (e.g. no backend on localhost). Shape matches `getWithdrawNetworks` in
 * `withdrawPageHelpers.js`.
 */

export const STATIC_WITHDRAW_COINS = [
  {
    _id: "static-currency-usdt",
    short_name: "USDT",
    name: "Tether",
    icon_path: "/images/tether_icon.png",
    chain: ["BEP20", "ERC20", "TRC20"],
    withdrawal_status: { BEP20: "ACTIVE", ERC20: "ACTIVE", TRC20: "ACTIVE" },
    min_withdrawal: { BEP20: "10", ERC20: "10", TRC20: "2" },
    max_withdrawal: { BEP20: "1000000", ERC20: "1000000", TRC20: "1000000" },
    withdrawal_fee: { BEP20: "0.29", ERC20: "3.5", TRC20: "1" },
    daily_withdraw_limit: 100000,
    remaining_24h_withdraw: 50000,
  },
  {
    _id: "static-currency-btc",
    short_name: "BTC",
    name: "Bitcoin",
    icon_path: "/images/bitcoin_icon.png",
    chain: ["BTC"],
    withdrawal_status: { BTC: "ACTIVE" },
    min_withdrawal: { BTC: "0.0002" },
    max_withdrawal: { BTC: "50" },
    withdrawal_fee: { BTC: "0.0005" },
    daily_withdraw_limit: 10,
    remaining_24h_withdraw: 5,
  },
  {
    _id: "static-currency-eth",
    short_name: "ETH",
    name: "Ethereum",
    icon_path: "/images/eth_currency_img.png",
    chain: ["ERC20"],
    withdrawal_status: { ERC20: "ACTIVE" },
    min_withdrawal: { ERC20: "0.002" },
    max_withdrawal: { ERC20: "500" },
    withdrawal_fee: { ERC20: "0.0015" },
    daily_withdraw_limit: 200,
    remaining_24h_withdraw: 100,
  },
  {
    _id: "static-currency-bnb",
    short_name: "BNB",
    name: "BNB",
    icon_path: "/images/AnnouncementImg/bnb_icon.svg",
    chain: ["BEP20"],
    withdrawal_status: { BEP20: "ACTIVE" },
    min_withdrawal: { BEP20: "0.002" },
    max_withdrawal: { BEP20: "2000" },
    withdrawal_fee: { BEP20: "0.0005" },
    daily_withdraw_limit: 500,
    remaining_24h_withdraw: 250,
  },
];

/** Match by symbol when API coin row has no `chain` — reuse bundled networks. */
export function findStaticWithdrawCoin(symbolOrCoin) {
  const raw =
    typeof symbolOrCoin === "object" && symbolOrCoin != null
      ? symbolOrCoin.short_name || symbolOrCoin.symbol || symbolOrCoin.name || ""
      : symbolOrCoin;
  const s = String(raw || "")
    .trim()
    .toUpperCase();
  if (!s || s === "—") return null;
  return STATIC_WITHDRAW_COINS.find((c) => String(c.short_name || "").toUpperCase() === s) || null;
}
